import React from "react";
import ReactDOM from "react-dom";
import WatchPlaylist from "./WatchPlaylist";

export default class WatchPlaylistContainer {
  constructor({ element }) {
    this.element = element;
    this.videoId = element.dataset.videoId;
    this.channelId = element.dataset.channelId;
    this.rendered = false;
  }

  init() {
    if (this.rendered) return;

    ReactDOM.render(
      <WatchPlaylist videoId={this.videoId} channelId={this.channelId} />,
      this.element
    );

    this.rendered = true;
  }
}
